import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import { TouchEvent } from '@/shared/common/touch/touch';

export class SectionCare {
	constructor(selector) {
		this.$container = selector;

		if (!this.$container) return;

		this.touchEvent = null;

		this.init();
	}

	init() {
		this.$sliderContainer = this.$container.querySelector('.swiper');
		this.$careCards = this.$container.querySelectorAll('.card-care');

		if (this.$sliderContainer) {
			new Swiper(this.$sliderContainer, {
				modules: [Pagination],
				slidesPerView: 1,
				spaceBetween: 24,
				breakpoints: {
					425: {
						slidesPerView: 'auto',
						spaceBetween: 24,
					},
					1280: {
						slidesPerView: 3,
						spaceBetween: 18,
						slidesOffsetBefore: 0,
						slidesOffsetAfter: 0,
					},
				},
				pagination: {
					el: this.$container.querySelector('.js-swiper-pagination'),
					clickable: true,
				},
			});
		}

		this.$careCards.forEach((element) => {
			element.addEventListener('touchstart', this.touchstartHeandler.bind(this));
			element.addEventListener('touchend', this.touchendHeandler.bind(this));
		});
	}

	touchstartHeandler(event) {
		this.touchEvent = new TouchEvent(event);
	}

	touchendHeandler(event) {
		if (!this.touchEvent) return;

		this.touchEvent.setEndEvent(event);

		if (this.touchEvent.isSwipeRight() || this.touchEvent.isSwipeLeft()) {
			this.toggle(event.target.closest('.card-care'));
		}

		this.touchEvent = null;
	}

	toggle(card) {
		card.classList.toggle('active');
	}
}
